import { put } from 'redux-saga/effects';

import actions from '../../../actions';

export function* openModal(type, data) {
  yield put(actions.openModal(type, data));
}

export function* closeModal() {
  yield put(actions.closeModal());
}

export default {
  openModal,
  closeModal,
};
